import DetailPageHeader from './DetailPageHeader';
import HeaderInfoAuthorized from './HeaderInfoAuthorized';
import RacePageHead from './RacePageHead';
import VenuesPage from './VenuesPage';
import HeaderContainer from './HeaderContainer';
import boostedOddsAnimation from './boostedOddsAnimation';

export default {
  USE_SIGN_UP_MODAL: true,
  EXPANDED_SELECTION: true,
  SORT_RACING_ODDS_MOBILE: true,
  DISABLE_SPORTS_DROPDOWN_MOBILE: true,
  MIX_PROMOTIONS_BONUSES: true,
  FAST_BETTING: true,
  DetailPageHeader,
  HeaderInfoAuthorized,
  RacePageHead,
  VenuesPage,
  HeaderContainer,
  boostedOddsAnimation,
  animations: {
    bonus: true,
    bonusConfetti: true,
  },
};
